unit SystemSetupVatSetup;

interface

uses
  System.SysUtils, System.Classes, JS, Web, WEBLib.Graphics, WEBLib.Controls,
  WEBLib.Forms, WEBLib.Dialogs, Vcl.StdCtrls, WEBLib.StdCtrls, WEBLib.DBCtrls,
  Vcl.Controls, WEBLib.ExtCtrls, Data.DB, WEBLib.DB, XData.Web.JsonDataset,
  XData.Web.Dataset, XData.Web.Client;

type
  TfrmSystemVatSetup = class(TForm)
    WebPanel1: TPanel;
    WebLabel96: TLabel;
    WebLabel95: TLabel;
    lblEnd: TLabel;
    WebDBEdit35: TDBEdit;
    WebPanel2: TPanel;
    WebDBDateTimePicker1: TDBDateTimePicker;
    WebDBDateTimePicker2: TDBDateTimePicker;
    dsVattable: TDataSource;
    wcVattable: TXDataWebClient;
    WebPanel3: TPanel;
    wdsVattable : TXDataWebDataSet;
    wdsVattableAuto: TIntegerField;
    wdsVattableVATPERC: TFloatField;
    wdsVattableSTARTDATE: TDateField;
    wdsVattableENDATE: TDateField;
    btnOk: TButton;
    btnCancel: TButton;
    procedure btnOkClick(Sender: TObject);
    procedure WebFormShow(Sender: TObject);
    procedure btnCancelClick(Sender: TObject);
  private
    { Private declarations }
    procedure LoadVattable;
  public
    { Public declarations }
    iState, iAuto : integer;
  protected procedure LoadDFMValues; override; end;

var
  frmSystemVatSetup: TfrmSystemVatSetup;

implementation

{$R *.dfm}

uses
  stfmssystem.connection,
  SystemAutoMailSetup,
  share.common;

procedure TfrmSystemVatSetup.btnCancelClick(Sender: TObject);
begin
  Close;
end;

procedure TfrmSystemVatSetup.btnOkClick(Sender: TObject);
  procedure OnSuccess(Response : TXDataClientResponse);
  begin
    wdsVattable.Cancel;
    Close;
  end;
  procedure OnError(Error: TXDataClientError);
  begin
    ShowMessage(Error.ErrorMessage);
    Close;
  end;

begin
  case iState of
    1:  Begin
          wcVattable.RawInvoke('IstfmsSystemService.Put_Vattable_insert',[GetJsonFromDataSet(wdsVattable)],@OnSuccess, @OnError);
        End;

    2:  Begin
          wcVattable.RawInvoke('IstfmsSystemService.Put_Vattable_Edit',[GetJsonFromDataSet(wdsVattable)],@OnSuccess, @OnError);
        End;
  end;//End case

end;

procedure TfrmSystemVatSetup.LoadVattable;
begin

end;

procedure TfrmSystemVatSetup.WebFormShow(Sender: TObject);
  procedure OnResultVattable(Response : TXDataClientResponse);
    begin
      wdsVattable.Close;
      wdsVattable.SetJsonData(TJSArray(TJSObject(Response.Result)['value']));
      wdsVattable.Open;

      if iState = 2 then
        Begin
          wdsVattable.Edit;
        End;

      console.log(GetJsonFromDataSet(wdsVattable));
    end;
begin

  case iState of
    1:  Begin
          wdsVattable.Open;
          wdsVattable.Insert;
        End;

    2:  Begin
          wcVattable.RawInvoke('IstfmsSystemService.Get_Vattable_View',[0,iAuto],@OnResultVattable);
        End;
  end;//End case

  lblEnd.Caption := IntToStr(iAuto);
end;


procedure TfrmSystemVatSetup.LoadDFMValues;
begin
  inherited LoadDFMValues;

  WebPanel1 := TPanel.Create(Self);
  WebLabel96 := TLabel.Create(Self);
  WebLabel95 := TLabel.Create(Self);
  lblEnd := TLabel.Create(Self);
  WebDBEdit35 := TDBEdit.Create(Self);
  WebPanel2 := TPanel.Create(Self);
  WebDBDateTimePicker1 := TDBDateTimePicker.Create(Self);
  WebDBDateTimePicker2 := TDBDateTimePicker.Create(Self);
  WebPanel3 := TPanel.Create(Self);
  btnOk := TButton.Create(Self);
  btnCancel := TButton.Create(Self);
  wcVattable := TXDataWebClient.Create(Self);
  wdsVattable := TXDataWebDataSet.Create(Self);
  wdsVattableVATPERC := TFloatField.Create(Self);
  wdsVattableSTARTDATE := TDateField.Create(Self);
  wdsVattableENDATE := TDateField.Create(Self);
  wdsVattableAuto := TIntegerField.Create(Self);
  dsVattable := TDataSource.Create(Self);

  WebPanel1.BeforeLoadDFMValues;
  WebLabel96.BeforeLoadDFMValues;
  WebLabel95.BeforeLoadDFMValues;
  lblEnd.BeforeLoadDFMValues;
  WebDBEdit35.BeforeLoadDFMValues;
  WebPanel2.BeforeLoadDFMValues;
  WebDBDateTimePicker1.BeforeLoadDFMValues;
  WebDBDateTimePicker2.BeforeLoadDFMValues;
  WebPanel3.BeforeLoadDFMValues;
  btnOk.BeforeLoadDFMValues;
  btnCancel.BeforeLoadDFMValues;
  wcVattable.BeforeLoadDFMValues;
  wdsVattable.BeforeLoadDFMValues;
  wdsVattableVATPERC.BeforeLoadDFMValues;
  wdsVattableSTARTDATE.BeforeLoadDFMValues;
  wdsVattableENDATE.BeforeLoadDFMValues;
  wdsVattableAuto.BeforeLoadDFMValues;
  dsVattable.BeforeLoadDFMValues;
  try
    Name := 'frmSystemVatSetup';
    Width := 623;
    Height := 192;
    SetEvent(Self, 'OnShow', 'WebFormShow');
    WebPanel1.SetParentComponent(Self);
    WebPanel1.Name := 'WebPanel1';
    WebPanel1.Left := 0;
    WebPanel1.Top := 0;
    WebPanel1.Width := 623;
    WebPanel1.Height := 192;
    WebPanel1.Align := alClient;
    WebPanel1.ChildOrder := 6;
    WebPanel1.TabOrder := 0;
    WebLabel96.SetParentComponent(WebPanel1);
    WebLabel96.Name := 'WebLabel96';
    WebLabel96.Left := 186;
    WebLabel96.Top := 67;
    WebLabel96.Width := 54;
    WebLabel96.Height := 15;
    WebLabel96.Caption := 'Start Date:';
    WebLabel96.HeightPercent := 100.000000000000000000;
    WebLabel96.WidthPercent := 100.000000000000000000;
    WebLabel95.SetParentComponent(WebPanel1);
    WebLabel95.Name := 'WebLabel95';
    WebLabel95.Left := 24;
    WebLabel95.Top := 67;
    WebLabel95.Width := 29;
    WebLabel95.Height := 15;
    WebLabel95.Caption := 'Vat%:';
    WebLabel95.HeightPercent := 100.000000000000000000;
    WebLabel95.WidthPercent := 100.000000000000000000;
    lblEnd.SetParentComponent(WebPanel1);
    lblEnd.Name := 'lblEnd';
    lblEnd.Left := 432;
    lblEnd.Top := 67;
    lblEnd.Width := 50;
    lblEnd.Height := 15;
    lblEnd.Caption := 'End Date:';
    lblEnd.HeightPercent := 100.000000000000000000;
    lblEnd.WidthPercent := 100.000000000000000000;
    WebDBEdit35.SetParentComponent(WebPanel1);
    WebDBEdit35.Name := 'WebDBEdit35';
    WebDBEdit35.Left := 24;
    WebDBEdit35.Top := 88;
    WebDBEdit35.Width := 121;
    WebDBEdit35.Height := 22;
    WebDBEdit35.ChildOrder := 2;
    WebDBEdit35.HeightPercent := 100.000000000000000000;
    WebDBEdit35.Text := 'WebDBEdit35';
    WebDBEdit35.WidthPercent := 100.000000000000000000;
    WebDBEdit35.DataField := 'VATPERC';
    WebDBEdit35.DataSource := dsVattable;
    WebPanel2.SetParentComponent(WebPanel1);
    WebPanel2.Name := 'WebPanel2';
    WebPanel2.Left := 0;
    WebPanel2.Top := 0;
    WebPanel2.Width := 623;
    WebPanel2.Height := 41;
    WebPanel2.Align := alTop;
    WebPanel2.Caption := 'VAT % Setup';
    WebPanel2.ChildOrder := 6;
    WebPanel2.Font.Charset := DEFAULT_CHARSET;
    WebPanel2.Font.Color := clWindowText;
    WebPanel2.Font.Height := -16;
    WebPanel2.Font.Name := 'Segoe UI';
    WebPanel2.Font.Style := [fsBold];
    WebPanel2.ParentFont := False;
    WebPanel2.TabOrder := 1;
    WebDBDateTimePicker1.SetParentComponent(WebPanel1);
    WebDBDateTimePicker1.Name := 'WebDBDateTimePicker1';
    WebDBDateTimePicker1.Left := 186;
    WebDBDateTimePicker1.Top := 88;
    WebDBDateTimePicker1.Width := 170;
    WebDBDateTimePicker1.Height := 22;
    WebDBDateTimePicker1.BorderStyle := bsSingle;
    WebDBDateTimePicker1.ChildOrder := 7;
    WebDBDateTimePicker1.Color := clWhite;
    WebDBDateTimePicker1.Date := 45720.756263495370000000;
    WebDBDateTimePicker1.Role := '';
    WebDBDateTimePicker1.Text := '';
    WebDBDateTimePicker1.DataField := 'STARTDATE';
    WebDBDateTimePicker1.DataSource := dsVattable;
    WebDBDateTimePicker2.SetParentComponent(WebPanel1);
    WebDBDateTimePicker2.Name := 'WebDBDateTimePicker2';
    WebDBDateTimePicker2.Left := 432;
    WebDBDateTimePicker2.Top := 88;
    WebDBDateTimePicker2.Width := 170;
    WebDBDateTimePicker2.Height := 22;
    WebDBDateTimePicker2.BorderStyle := bsSingle;
    WebDBDateTimePicker2.ChildOrder := 8;
    WebDBDateTimePicker2.Color := clWhite;
    WebDBDateTimePicker2.Date := 45720.756277581020000000;
    WebDBDateTimePicker2.Role := '';
    WebDBDateTimePicker2.Text := '';
    WebDBDateTimePicker2.Visible := False;
    WebDBDateTimePicker2.DataField := 'ENDATE';
    WebDBDateTimePicker2.DataSource := dsVattable;
    WebPanel3.SetParentComponent(WebPanel1);
    WebPanel3.Name := 'WebPanel3';
    WebPanel3.Left := 0;
    WebPanel3.Top := 132;
    WebPanel3.Width := 623;
    WebPanel3.Height := 60;
    WebPanel3.Align := alBottom;
    WebPanel3.ChildOrder := 9;
    WebPanel3.TabOrder := 2;
    btnOk.SetParentComponent(WebPanel3);
    btnOk.Name := 'btnOk';
    btnOk.Left := 41;
    btnOk.Top := 19;
    btnOk.Width := 96;
    btnOk.Height := 25;
    btnOk.Caption := 'Continue';
    btnOk.Color := clGreenyellow;
    btnOk.HeightPercent := 100.000000000000000000;
    btnOk.WidthPercent := 100.000000000000000000;
    SetEvent(btnOk, Self, 'OnClick', 'btnOkClick');
    btnCancel.SetParentComponent(WebPanel3);
    btnCancel.Name := 'btnCancel';
    btnCancel.Left := 160;
    btnCancel.Top := 19;
    btnCancel.Width := 96;
    btnCancel.Height := 25;
    btnCancel.Caption := 'cancel';
    btnCancel.Color := clRed;
    btnCancel.ChildOrder := 1;
    btnCancel.HeightPercent := 100.000000000000000000;
    btnCancel.WidthPercent := 100.000000000000000000;
    SetEvent(btnCancel, Self, 'OnClick', 'btnCancelClick');
    wcVattable.SetParentComponent(Self);
    wcVattable.Name := 'wcVattable';
    wcVattable.Connection := dmData.dbConnect;
    wcVattable.Left := 24;
    wcVattable.Top := 28;
    wdsVattable.SetParentComponent(Self);
    wdsVattable.Name := 'wdsVattable';
    wdsVattable.Connection := dmData.dbConnect;
    wdsVattable.Left := 72;
    wdsVattable.Top := 28;
    wdsVattableVATPERC.SetParentComponent(wdsVattable);
    wdsVattableVATPERC.Name := 'wdsVattableVATPERC';
    wdsVattableVATPERC.FieldName := 'VATPERC';
    wdsVattableSTARTDATE.SetParentComponent(wdsVattable);
    wdsVattableSTARTDATE.Name := 'wdsVattableSTARTDATE';
    wdsVattableSTARTDATE.FieldName := 'STARTDATE';
    wdsVattableENDATE.SetParentComponent(wdsVattable);
    wdsVattableENDATE.Name := 'wdsVattableENDATE';
    wdsVattableENDATE.FieldName := 'ENDATE';
    wdsVattableAuto.SetParentComponent(wdsVattable);
    wdsVattableAuto.Name := 'wdsVattableAuto';
    wdsVattableAuto.FieldName := 'Auto';
    dsVattable.SetParentComponent(Self);
    dsVattable.Name := 'dsVattable';
    dsVattable.DataSet := wdsVattable;
    dsVattable.Left := 120;
    dsVattable.Top := 28;
  finally
    WebPanel1.AfterLoadDFMValues;
    WebLabel96.AfterLoadDFMValues;
    WebLabel95.AfterLoadDFMValues;
    lblEnd.AfterLoadDFMValues;
    WebDBEdit35.AfterLoadDFMValues;
    WebPanel2.AfterLoadDFMValues;
    WebDBDateTimePicker1.AfterLoadDFMValues;
    WebDBDateTimePicker2.AfterLoadDFMValues;
    WebPanel3.AfterLoadDFMValues;
    btnOk.AfterLoadDFMValues;
    btnCancel.AfterLoadDFMValues;
    wcVattable.AfterLoadDFMValues;
    wdsVattable.AfterLoadDFMValues;
    wdsVattableVATPERC.AfterLoadDFMValues;
    wdsVattableSTARTDATE.AfterLoadDFMValues;
    wdsVattableENDATE.AfterLoadDFMValues;
    wdsVattableAuto.AfterLoadDFMValues;
    dsVattable.AfterLoadDFMValues;
  end;
end;

end.
